export enum ContractsMileageListQueryParamsOrder {
  COMPANY_NAME_ASC = "COMPANY_NAME_ASC",
  COMPANY_NAME_DESC = "COMPANY_NAME_DESC",
  VALID_SINCE_ASC = "VALID_SINCE_ASC",
  VALID_SINCE_DESC = "VALID_SINCE_DESC",
  VALID_TO_ASC = "VALID_TO_ASC",
  VALID_TO_DESC = "VALID_TO_DESC",
}

export type ContractsMileageListQueryParams = {
  offset?: number;
  limit?: number;
  isValid?: boolean;
  cargoCompanyId?: string;
  cargoCompanyName?: string;
  order?: ContractsMileageListQueryParamsOrder;
};

type ContractsMileageListRequest = {
  page?: number;
  pageSize?: number;
  isValid?: boolean;
  cargoCompanyUuid?: string;
  cargoCompanyName?: string;
  order?: ContractsMileageListQueryParamsOrder;
};

export default ContractsMileageListRequest;
